import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage"; // Add this import

const firebaseConfig = {
  apiKey: "AIzaSyDdZ9DvgIAK4b6y7CKVVzTJzjTGEmHntIo",
  authDomain: "pay2pee-8af3d.firebaseapp.com",
  projectId: "pay2pee-8af3d",
  storageBucket: "pay2pee-8af3d.firebasestorage.app", // Ensure this matches your Firebase Console
  messagingSenderId: "61474381543",
  appId: "1:61474381543:web:c2bdcdf5c69fcc4498cc42"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(app); // Add this line

export { app, storage }; // Explicitly export storage

